export default __webpack_public_path__ + "static/media/predictive-character-seeking-lg.84df85e4.jpg";